import { doc, updateDoc } from 'firebase/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import { isValidDocumentId } from '../utils/utils';

export const useSuperUserMutators = () => {
  const { isAuthGod, user } = useAuth();

  const toggleGodStatus = async (isGod: boolean): Promise<void> => {
    if (!isAuthGod) {
      throw new Error('Only auth gods can toggle god status');
    }

    if (!user?.uid) {
      throw new Error('User not authenticated');
    }

    try {
      const superUserRef = doc(firestore, 'superUser', user.uid);
      await updateDoc(superUserRef, { isGod });
    } catch (error) {
      console.error('Error toggling god status:', error);
      throw error;
    }
  };

  const cancelImpersonation = async (): Promise<void> => {
    if (!isAuthGod) {
      throw new Error('Only auth gods can cancel impersonation');
    }

    if (!user?.uid) {
      throw new Error('User not authenticated');
    }

    try {
      const superUserRef = doc(firestore, 'superUser', user.uid);
      await updateDoc(superUserRef, { impersonate: '' });
    } catch (error) {
      console.error('Error canceling impersonation:', error);
      throw error;
    }
  };

  const startImpersonation = async (profileId: string): Promise<void> => {
    if (!isAuthGod) {
      throw new Error('Only auth gods can start impersonation');
    }

    if (!user?.uid) {
      throw new Error('User not authenticated');
    }

    if (!profileId.trim()) {
      throw new Error('Profile ID is required');
    }

    if (!isValidDocumentId(profileId.trim())) {
      throw new Error('Not a profile ID');
    }

    try {
      const superUserRef = doc(firestore, 'superUser', user.uid);
      await updateDoc(superUserRef, { impersonate: profileId.trim() });
    } catch (error) {
      console.error('Error starting impersonation:', error);
      throw error;
    }
  };

  return {
    cancelImpersonation,
    startImpersonation,
    toggleGodStatus,
  };
};
